module.exports = __webpack_public_path__ + "static/cta-three-bg-1-1-f18d4f8a1a3c3eadfe1dc0eeffc85d3d.png";